import {getFirstNameColumnDef} from './utils/get-first-name-column-def';
import {getLastNameColumnDef} from './utils/get-last-name-column-def';

export {type StudentRowModel} from './types';

export const getStudentsTableColumnDef = {
	firstName: getFirstNameColumnDef,
	lastName: getLastNameColumnDef,
};
